import { FC } from 'react';
import { AspectRatio, Box, Image } from '@chakra-ui/react';

interface CoverProps {
  src: string;
  ratio?: number;
}

const Cover: FC<CoverProps> = ({ ratio = 2.5, src }) => (
  <Box paddingBottom="space-40" paddingTop="space-20">
    <AspectRatio ratio={ratio}>
      <Image borderRadius={8} objectFit="cover" src={src} width="100%" />
    </AspectRatio>
  </Box>
);

export default Cover;
